"use client";

import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { RiSearchLine } from "react-icons/ri";
import { Checkbox } from "@/components/ui/checkbox";
import Input from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Controlled presentation, also used by the retained general shipment picker. */
export function LotSelectionSearch(t0) {
  const $ = _c(11);
  const {
    value,
    onChange,
    listId,
    placeholder: t1
  } = t0;
  const placeholder = t1 === undefined ? "Search lots..." : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RiSearchLine className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-foreground-muted" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onChange) {
    t3 = event => onChange(event.target.value);
    $[1] = onChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== listId) {
    t4 = event_0 => {
      if (!["ArrowDown", "ArrowUp", "Enter"].includes(event_0.key)) {
        return;
      }
      const list = document.getElementById(listId);
      const searchResults = list?.querySelector("[data-lot-picker-search-results]") ?? list;
      const choices = searchResults?.querySelectorAll("[data-lot-picker-choice]:not(:disabled)");
      const choice = event_0.key === "ArrowUp" ? choices?.[choices.length - 1] : choices?.[0];
      if (!choice) {
        return;
      }
      event_0.preventDefault();
      choice.focus();
      if (event_0.key === "Enter") {
        choice.click();
      }
    };
    $[3] = listId;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== listId || $[6] !== placeholder || $[7] !== t3 || $[8] !== t4 || $[9] !== value) {
    t5 = <div className="relative">{t2}<Input aria-label="Search lots" aria-controls={listId} placeholder={placeholder} value={value} onChange={t3} onKeyDown={t4} className="pl-9" /></div>;
    $[5] = listId;
    $[6] = placeholder;
    $[7] = t3;
    $[8] = t4;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function LotSelectionDepletedToggle(t0) {
  const $ = _c(11);
  const {
    checked,
    onChange
  } = t0;
  const controlId = useId();
  let t1;
  if ($[0] !== onChange) {
    t1 = value => onChange(value === true);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== checked || $[3] !== controlId || $[4] !== t1) {
    t2 = <Checkbox id={controlId} checked={checked} className="border-border bg-background" onCheckedChange={t1} />;
    $[2] = checked;
    $[3] = controlId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== controlId) {
    t3 = <Label htmlFor={controlId} className="text-caption font-normal text-foreground-secondary">Show depleted lots</Label>;
    $[6] = controlId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex items-center gap-2 px-2">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}